import Modal from '../Modal';
import styles from './DeleteModal.module.scss';
import Button from '../Button';
import Typography from '../Typography';

type Props = {
  openModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  onDelete: () => void;
  text: string;
  component?: React.ReactNode;
  confirmText?: string;
  buttonType?: 'danger' | 'gray' | 'green' | 'primary' | 'blue';
  title?: string;
};

const DeleteModal = ({
  openModal,
  setOpenModal,
  onDelete,
  text,
  component,
  confirmText,
  buttonType = 'danger',
  title = 'Delete confirmation',
}: Props) => {
  return (
    <Modal
      isOpen={openModal}
      onRequestClose={() => setOpenModal(false)}
      onClose={() => setOpenModal(false)}
      className={styles.modal_wrapper}
    >
      <Typography variant="h2">{title}</Typography>
      <div className={styles.textWrapper}>
        <Typography className={styles.text} variant="p">
          {text}
        </Typography>
      </div>
      {component}
      <div className={styles.actionWrapper} style={{marginTop: 25}}>
        <Button onClick={onDelete} color={buttonType}>
          {confirmText || 'Delete'}
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
